import { type StateCreator } from "zustand";
export type { UserData } from "@vTypes/user-type";

/**
 * login Modal slice 
 * - login Modal 상태 관리
 */

export interface LoginModalSlice {
  view: boolean;
  setOpen: (view: boolean) => void,
  setclose: (view: boolean) => void,
}

export const createLoginModalSlice: StateCreator<LoginModalSlice> = (set) => ({
    view: false,   
    setOpen: () => set({ view: true,}),
    setclose: () => set({ view: false,}),
});
